const rankings = [
  { id: 1, rank: 1, title: '繁花', category: '电视剧', heat: '本周最热', score: '9.4', trend: 'up' },
  { id: 2, rank: 2, title: '流浪地球3', category: '电影', heat: '热度飙升', score: '8.7', trend: 'up' },
  { id: 3, rank: 3, title: '庆余年2', category: '电视剧', heat: '持续热播', score: '9.1', trend: 'same' },
  { id: 4, rank: 4, title: '封神第二部', category: '电影', heat: '新上架', score: '8.9', trend: 'up' },
  { id: 5, rank: 5, title: '三体·动画版', category: '动漫', heat: '连载热追', score: '8.5', trend: 'up' },
  { id: 6, rank: 6, title: '大江大河3', category: '电视剧', heat: '口碑佳作', score: '8.8', trend: 'same' },
  { id: 7, rank: 7, title: '熊出没·逆转时空', category: '电影', heat: '合家欢首选', score: '8.3', trend: 'up' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-8 md:gap-12">
          <div className="flex-1 w-full">
            <div className="mb-8 md:mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                热度榜单
              </h2>
              <p className="text-sm text-foreground-500 mt-1">全网热播影视排行，发现大家都在看什么</p>
            </div>

            <div className="space-y-2">
              {rankings.map((item) => (
                <div
                  key={item.id}
                  className="flex items-center gap-3 md:gap-4 p-3 md:p-4 rounded-xl bg-background-50 hover:bg-background-200 cursor-pointer transition-colors duration-200"
                >
                  <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 font-heading font-bold text-sm ${
                    item.rank === 1 ? 'bg-primary-500 text-white' :
                    item.rank === 2 ? 'bg-accent-500 text-white' :
                    item.rank === 3 ? 'bg-secondary-500 text-white' :
                    'bg-background-200 text-foreground-500'
                  }`}>
                    {item.rank}
                  </div>

                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground-800 truncate">{item.title}</p>
                    <p className="text-xs text-foreground-500 whitespace-nowrap">{item.category}</p>
                  </div>

                  <div className="flex-shrink-0 text-right">
                    <div className="flex items-center gap-1">
                      <span className="text-sm font-heading font-bold text-foreground-900 whitespace-nowrap">{item.score}</span>
                      <i className={`text-xs ${
                        item.trend === 'up' ? 'ri-arrow-up-line text-primary-500' : 'ri-subtract-line text-foreground-400'
                      }`}></i>
                    </div>
                    <span className="text-xs text-accent-500 whitespace-nowrap">{item.heat}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex-1 w-full flex items-center justify-center">
            <div className="relative w-full max-w-[440px] aspect-[3/4] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20cinematic%20golden%20trophy%20or%20film%20award%20on%20a%20pedestal%20with%20dramatic%20spotlight%2C%20warm%20amber%20and%20crimson%20lighting%2C%20elegant%20theater%20background%2C%20prestige%20and%20celebration%20atmosphere%2C%20cinematic%20composition%2C%20no%20text&width=880&height=1170&seq=ranking-visual&orientation=portrait"
                alt="成全影视热度榜单"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}